'use strict';

var AppointmentModalBaseCtrl = require('./AppointmentModalBaseCtrl');

var CustomerAppointmentModalCtrl = function(
  $controller,
  $injector,
  $timeout,
  $rootScope,
  appointment,
  customers,
  customLabels,
  gettextCatalog,
  modalInstance,
  resources,
  services,
  office,
) {
  AppointmentModalBaseCtrl.call(this, modalInstance, $injector);

  var initialEmployeeId = _.get(appointment, 'object._id');
  this.customerLabel = gettextCatalog.getString(customLabels.customer.toLowerCase());
  this.customers = customers;
  this.services = services;
  this.appointment = appointment;
  this.resources = resources;
  this.rootScope = $rootScope;
  this._timeout = $timeout;
  this.office = office;
  this.isCreatedByCoach = appointment.createdBy === 'coach';
  this.smsReminderEnabled = _.get(this.office, 'settings.reminder.sms.enabled');
  this.emailReminderEnabled = _.get(this.office, 'settings.reminder.email.enabled');
  this.showReminderTab = this.smsReminderEnabled || this.emailReminderEnabled;
  this.currentService = null;
  this.sendNotificationEnabled = _.get(
    office,
    'settings.sendAppointmentChangeNotificationMails',
    false,
  );
  var customerFullName = _.get(this.appointment, 'customer.fullname');

  if (customerFullName) {
    this.title = gettextCatalog.getString('Appointment with {{customer}}', {
      customer: customerFullName,
    });
  } else {
    this.title = gettextCatalog.getString('Appointment with {{customer}}', {
      customer: _.get(this.appointment, 'customer.firstname', '?'),
    });
  }

  // set default resource
  if (!initialEmployeeId) {
    this.appointment.object = {
      _id: this.resources.employees[0]._id,
    };
  }

  if (!appointment._id) {
    var emailEnabled = _.get(office, 'settings.reminder.email.enabled', false);
    var smsEnabled = _.get(office, 'settings.reminder.sms.enabled', false);

    this.appointment.reminder = {
      email: {
        enabled: emailEnabled,
      },
      sms: {
        enabled: smsEnabled,
      },
    };

    if (resources.rooms && resources.rooms.length) {
      this.appointment.room = resources.rooms[0]._id;
    }
  }

  if (_.get(this, 'appointment.reminder.sms.enabled') && this.isCreatedByCoach) {
    this.appointment.reminder.sms.enabled = false;
  }

  // set sendNotifications
  if (this.sendNotificationEnabled && this.appointment.sendNotifications === undefined) {
    this.appointment.sendNotifications = true;
  }

  this.selectServicesForEmployee(this.appointment.object._id);
  this.recurringSettingsWatcher = this.watchRecurringSettings();
};

CustomerAppointmentModalCtrl.prototype = new AppointmentModalBaseCtrl();

CustomerAppointmentModalCtrl.prototype.selectServicesForEmployee = function(employeeId) {
  this.employeeServices = _.filter(this.services, function(service) {
    if (service.resources.employee.indexOf(employeeId) > -1) {
      return true;
    } else {
      return false;
    }
  });
};

CustomerAppointmentModalCtrl.prototype.currentServiceChanged = function() {
  if (this.currentService) {
    this.selectService(this.currentService);
    this.currentService = null;
  }
};

/**
 * calc the duration and overall price
 *
 * @param {Boolean} recalcDuration
 */
CustomerAppointmentModalCtrl.prototype.calcPriceAndDuration = function(recalcDuration) {
  var self = this;
  this.appointment.price = 0;
  this.duration = 0;

  _.forEach(this.appointment.services, function(service) {
    if (service.price) {
      self.appointment.price += _.toNumber(service.price);
    }

    self.duration += service.duration;
  });

  this.duration = this.duration === 0 ? 30 : this.duration;

  if (recalcDuration) {
    self.appointment.end = moment(self.appointment.start)
      .add(self.duration, 'minutes')
      .toDate();
  }
};

/**
 * add a service to appointment
 */
CustomerAppointmentModalCtrl.prototype.selectService = function($item) {
  var selectedService = {
    _id: $item._id,
    name: $item.name,
    duration: $item.duration,
    price: $item.price,
    shorthand: $item.shorthand,
  };

  this.appointment.services.push(selectedService);
  this.calcPriceAndDuration(true);
  this.service = '';
};

/**
 * remove service from appointment
 * @param {Number} index
 */
CustomerAppointmentModalCtrl.prototype.removeService = function(index) {
  this.appointment.services.splice(index, 1);
  this.calcPriceAndDuration();
};

/**
 * move a service up or down in service list
 * @param {Number} index
 * @param {Number} direction
 */
CustomerAppointmentModalCtrl.prototype.moveService = function(index, direction) {
  if (direction > 0) {
    if (index > 0) {
      this.appointment.services.move(index, index - 1);
    }
  } else {
    if (index < this.appointment.services.length - 1) {
      this.appointment.services.move(index, index + 1);
    }
  }
};

module.exports = CustomerAppointmentModalCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/calendar/CustomerAppointmentModalCtrl.js